import * as types from "../../actions/ActionTypes"; 
const initialState = {
    loading: false,
    data: null,
    error: null,
};

const getPostCommentsReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.GET_COMMENTS_START:
            return {
                ...state,
                loading: true,
                error: null,
            };

        case types.GET_COMMENTS_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
                error: null,
            };

        case types.GET_COMMENTS_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        default:
            return state;
    }
};

export default getPostCommentsReducer;
